import { useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import useMountEffect from '@zenbusiness/application-commons-hooks/useMountEffect';
import SharedLottieAsset from '@zenbusiness/zui/SharedLottieAsset';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import InterstitialScreen from '#client/components/InterstitialScreen';
import RotatingText from '#client/components/RotatingText';

import PostOrderLogin from '../PostOrderLogin';

function PostOrderScreen({ loginCredentials }) {
  const { sizes } = useBreakpoints();
  const trackScreenViewed = useClickstreamCallback('screenViewed');
  const [shouldLogin, setShouldLogin] = useState(false);
  const { email, password } = loginCredentials;

  const handleRotateTextComplete = useCallback(() => {
    setShouldLogin(true);
  }, [setShouldLogin]);

  const startComponent = (
    <SharedLottieAsset
      alt="Confirming order"
      height={sizes.isMobile ? 128 : 256}
      src="/s2/animation/lottie/confirm-folder-fill.json"
    />
  );

  const titleComponent = (
    <RotatingText
      slots={{ text: InterstitialScreen.Title }}
      textOptions={[
        'Confirming your order details...',
        'Sending your info to our team...',
        `Remember, you can review your order status from your dashboard once it's submitted`
      ]}
      onComplete={handleRotateTextComplete}
    />
  );

  useMountEffect(() => {
    trackScreenViewed({
      appPageName: 'checkout_smart_llc_post_order_screen'
    });
  });

  if (shouldLogin) {
    return <PostOrderLogin email={email} password={password} />;
  }

  return (
    <InterstitialScreen
      slots={{
        start: startComponent,
        title: titleComponent
      }}
      subtitle="This may take a few moments."
    />
  );
}

PostOrderScreen.propTypes = {
  loginCredentials: PropTypes.shape({
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired
  }).isRequired
};

export default PostOrderScreen;
